(function () {
  // El script en linea de sections/main-collection.liquid se desactiva con
  // __sirenaExcelCatalogXlsxInit (lo pone snippets/sections/sirena-excel-catalog.liquid).
  // Este archivo usa su propio guard para no auto-anularse.
  if (window.__sirenaExcelCatalogV2Init) return;
  window.__sirenaExcelCatalogV2Init = true;
  window.__sirenaExcelCatalogXlsxInit = true;
  const CFG = window.SIRENA_EXCEL_CFG || {};
  const COLLECTION_HANDLE = CFG.handle || "";
  const COLLECTION_TITLE = CFG.title || "Catalogo";
  const SHOP_DOMAIN = CFG.domain || window.location.origin;
  const PRICE_VIEW = CFG.priceView || "precios";
  const EXCELJS_URL =
    "https://cdn.jsdelivr.net/npm/exceljs@4.4.0/dist/exceljs.min.js";
  const IMAGE_DOWNLOAD_SIZE = 500;
  const IMAGE_CANVAS_SIZE = 320;
  const IMAGE_EXCEL_SIZE = 92;
  const IMAGE_QUALITY = 0.86;
  const MAX_DESCRIPTION_LENGTH = 450;
  const preparedImageCache = new Map();
  const workbookImageCache = new Map();
  function cleanText(html) {
    const container = document.createElement("div");
    container.innerHTML = html || "";
    return (container.textContent || container.innerText || "")
      .replace(/\s+/g, " ")
      .trim();
  }
  function safeFileName(value) {
    return String(value || "catalogo")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[<>:"/\\|?*\u0000-\u001f]/g, "-")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
      .toLowerCase();
  }
  function safeSheetName(value) {
    return String(value || "Catálogo")
      .replace(/[\\/*?:[\]]/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 31) || "Catálogo";
  }
  function loadExcelJS() {
    return new Promise(function (resolve, reject) {
      if (window.ExcelJS) {
        resolve(window.ExcelJS);
        return;
      }
      const existingScript = document.querySelector(
        'script[data-sirena-exceljs="true"]'
      );
      if (existingScript) {
        existingScript.addEventListener("load", function () {
          if (window.ExcelJS) {
            resolve(window.ExcelJS);
          } else {
            reject(new Error("ExcelJS no quedó disponible."));
          }
        });
        existingScript.addEventListener("error", function () {
          reject(new Error("No se pudo cargar el generador de Excel."));
        });
        return;
      }
      const script = document.createElement("script");
      script.src = EXCELJS_URL;
      script.async = true;
      script.dataset.sirenaExceljs = "true";
      script.onload = function () {
        if (window.ExcelJS) {
          resolve(window.ExcelJS);
        } else {
          reject(new Error("ExcelJS no quedó disponible."));
        }
      };
      script.onerror = function () {
        reject(new Error("No se pudo cargar el generador de Excel."));
      };
      document.head.appendChild(script);
    });
  }
  async function getProducts() {
    let allProducts = [];
    let page = 1;
    while (true) {
      const url =
        "/collections/" +
        encodeURIComponent(COLLECTION_HANDLE) +
        "/products.json?limit=250&page=" +
        page;
      const response = await fetch(url, {
        credentials: "same-origin"
      });
      if (!response.ok) {
        throw new Error(
          "No se pudieron leer los productos de la colección."
        );
      }
      const data = await response.json();
      const products = Array.isArray(data.products)
        ? data.products
        : [];
      allProducts = allProducts.concat(products);
      if (products.length < 250) break;
      page++;
      if (page > 100) {
        throw new Error("La colección contiene demasiadas páginas.");
      }
    }
    return allProducts;
  }
  async function getPriceMap() {
    const map = new Map();
    let page = 1;
    // Solo se llena si el cliente conectado tiene etiqueta de lista de precio:
    // la vista Liquid decide, aqui solo se lee lo que llega.
    map.conInventario = false;

    while (true) {
      const url =
        "/collections/" +
        encodeURIComponent(COLLECTION_HANDLE) +
        "?view=" +
        encodeURIComponent(PRICE_VIEW) +
        "&page=" +
        page;

      let data;

      try {
        const response = await fetch(url, {
          credentials: "same-origin"
        });

        if (!response.ok) break;

        data = JSON.parse(await response.text());
      } catch (error) {
        console.warn(
          "No se pudieron leer los precios de lista:",
          error
        );
        break;
      }

      if (data.inventario === true) {
        map.conInventario = true;
      }

      (data.items || []).forEach(function (item) {
        map.set(String(item.id), item);
      });

      if (!data.pages || page >= data.pages) break;

      page++;

      if (page > 100) break;
    }

    return map;
  }

  function toNumber(value) {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function resolvePrices(variant, listInfo) {
    const price = toNumber(variant.price);
    const compareAt = toNumber(variant.compare_at_price);
    const listPrice = listInfo
      ? toNumber(listInfo.lista)
      : null;

    if (price === null) {
      return { normal: null, offer: null, hasOffer: false };
    }

    let normal = price;
    let offer = price;

    if (compareAt !== null && compareAt > price) {
      normal = compareAt;
      offer = price;
    }

    if (listPrice !== null && listPrice > 0 && listPrice < offer) {
      offer = listPrice;
    }

    return {
      normal: normal,
      offer: offer,
      hasOffer: offer < normal
    };
  }

  // Devuelve lo que se escribe en la columna Inventario y con que color.
  function resolveStock(listInfo) {
    if (!listInfo || listInfo.inv === undefined || listInfo.inv === null) {
      return { value: "", color: "FF1F2937", bold: false };
    }
    if (listInfo.inv === "sin_control") {
      return { value: "Sin control", color: "FF6B7280", bold: false };
    }
    const cantidad = toNumber(listInfo.inv);
    if (cantidad === null) {
      return { value: "", color: "FF1F2937", bold: false };
    }
    let color = "FF15803D";
    if (cantidad <= 0) {
      color = "FFB91C1C";
    } else if (cantidad <= 5) {
      color = "FFB45309";
    }
    return { value: cantidad, color: color, bold: true };
  }

  function getVariantImage(product, variant) {
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === "string") {
        return variant.featured_image;
      }
      if (variant.featured_image.src) {
        return variant.featured_image.src;
      }
    }
    if (variant && variant.image) {
      if (typeof variant.image === "string") {
        return variant.image;
      }
      if (variant.image.src) {
        return variant.image.src;
      }
    }
    if (
      variant &&
      variant.image_id &&
      Array.isArray(product.images)
    ) {
      const matchingImage = product.images.find(function (image) {
        return String(image.id) === String(variant.image_id);
      });
      if (matchingImage && matchingImage.src) {
        return matchingImage.src;
      }
    }
    if (product.image && product.image.src) {
      return product.image.src;
    }
    if (
      Array.isArray(product.images) &&
      product.images.length &&
      product.images[0].src
    ) {
      return product.images[0].src;
    }
    return "";
  }
  function getShopifyImageUrl(src, width) {
    if (!src) return "";
    try {
      const url = new URL(src, window.location.origin);
      url.protocol = "https:";
      url.searchParams.set("width", String(width));
      return url.toString();
    } catch (error) {
      return src;
    }
  }
  function loadImageFromBlob(blob) {
    return new Promise(function (resolve, reject) {
      const objectUrl = URL.createObjectURL(blob);
      const image = new Image();
      image.onload = function () {
        URL.revokeObjectURL(objectUrl);
        resolve(image);
      };
      image.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        reject(new Error("No se pudo preparar la imagen."));
      };
      image.src = objectUrl;
    });
  }
  async function imageUrlToJpegBase64(src) {
    if (!src) return null;
    const imageUrl = getShopifyImageUrl(
      src,
      IMAGE_DOWNLOAD_SIZE
    );
    if (preparedImageCache.has(imageUrl)) {
      return preparedImageCache.get(imageUrl);
    }
    const imagePromise = (async function () {
      try {
        const response = await fetch(imageUrl, {
          mode: "cors",
          credentials: "omit",
          cache: "force-cache"
        });
        if (!response.ok) {
          throw new Error("No se pudo descargar la imagen.");
        }
        const blob = await response.blob();
        const image = await loadImageFromBlob(blob);
        const canvas = document.createElement("canvas");
        canvas.width = IMAGE_CANVAS_SIZE;
        canvas.height = IMAGE_CANVAS_SIZE;
        const context = canvas.getContext("2d");
        if (!context) {
          throw new Error("El navegador no permite procesar imágenes.");
        }
        context.fillStyle = "#FFFFFF";
        context.fillRect(
          0,
          0,
          IMAGE_CANVAS_SIZE,
          IMAGE_CANVAS_SIZE
        );
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = "high";
        const padding = 12;
        const availableSize =
          IMAGE_CANVAS_SIZE - padding * 2;
        const naturalWidth =
          image.naturalWidth || image.width || 1;
        const naturalHeight =
          image.naturalHeight || image.height || 1;
        const scale = Math.min(
          availableSize / naturalWidth,
          availableSize / naturalHeight
        );
        const drawWidth = Math.max(
          1,
          Math.round(naturalWidth * scale)
        );
        const drawHeight = Math.max(
          1,
          Math.round(naturalHeight * scale)
        );
        const drawX = Math.round(
          (IMAGE_CANVAS_SIZE - drawWidth) / 2
        );
        const drawY = Math.round(
          (IMAGE_CANVAS_SIZE - drawHeight) / 2
        );
        context.drawImage(
          image,
          drawX,
          drawY,
          drawWidth,
          drawHeight
        );
        return canvas.toDataURL(
          "image/jpeg",
          IMAGE_QUALITY
        );
      } catch (error) {
        console.warn(
          "No se pudo insertar una imagen en el Excel:",
          imageUrl,
          error
        );
        return null;
      }
    })();
    preparedImageCache.set(imageUrl, imagePromise);
    return imagePromise;
  }
  function getProductLink(product, variant) {
    let link =
      SHOP_DOMAIN +
      "/products/" +
      encodeURIComponent(product.handle || "");
    if (variant && variant.id) {
      link += "?variant=" + encodeURIComponent(variant.id);
    }
    return link;
  }
  function getVariantTitle(variant) {
    const title = String(
      variant && variant.title ? variant.title : ""
    ).trim();
    if (
      !title ||
      title.toLowerCase() === "default title"
    ) {
      return "Producto único";
    }
    return title;
  }
  function flattenProducts(products) {
    const items = [];
    products.forEach(function (product) {
      const variants =
        Array.isArray(product.variants) &&
        product.variants.length
          ? product.variants
          : [{}];
      variants.forEach(function (variant) {
        items.push({
          product: product,
          variant: variant
        });
      });
    });
    return items;
  }
  function applyThinBorder(cell) {
    cell.border = {
      top: {
        style: "thin",
        color: { argb: "FFD6DCE4" }
      },
      left: {
        style: "thin",
        color: { argb: "FFD6DCE4" }
      },
      bottom: {
        style: "thin",
        color: { argb: "FFD6DCE4" }
      },
      right: {
        style: "thin",
        color: { argb: "FFD6DCE4" }
      }
    };
  }
  async function getWorkbookImageId(
    workbook,
    imageUrl
  ) {
    if (!imageUrl) return null;
    const normalizedUrl = getShopifyImageUrl(
      imageUrl,
      IMAGE_DOWNLOAD_SIZE
    );
    if (workbookImageCache.has(normalizedUrl)) {
      return workbookImageCache.get(normalizedUrl);
    }
    const imageIdPromise = (async function () {
      const base64 =
        await imageUrlToJpegBase64(normalizedUrl);
      if (!base64) return null;
      return workbook.addImage({
        base64: base64,
        extension: "jpeg"
      });
    })();
    workbookImageCache.set(
      normalizedUrl,
      imageIdPromise
    );
    return imageIdPromise;
  }
  async function insertImages(
    workbook,
    worksheet,
    imageTasks,
    button
  ) {
    if (!imageTasks.length) return;
    let nextIndex = 0;
    let completed = 0;
    const workerCount = Math.min(
      5,
      imageTasks.length
    );
    async function worker() {
      while (true) {
        const currentIndex = nextIndex;
        nextIndex++;
        if (currentIndex >= imageTasks.length) {
          return;
        }
        const task = imageTasks[currentIndex];
        try {
          const imageId =
            await getWorkbookImageId(
              workbook,
              task.imageUrl
            );
          if (imageId !== null) {
            worksheet.addImage(imageId, {
              tl: {
                col: 1.22,
                row: task.rowNumber - 1 + 0.16
              },
              ext: {
                width: IMAGE_EXCEL_SIZE,
                height: IMAGE_EXCEL_SIZE
              },
              editAs: "oneCell"
            });
          }
        } catch (error) {
          console.warn(
            "No se pudo añadir la imagen:",
            error
          );
        }
        completed++;
        button.textContent =
          "Procesando imágenes " +
          completed +
          "/" +
          imageTasks.length +
          "...";
      }
    }
    const workers = [];
    for (let index = 0; index < workerCount; index++) {
      workers.push(worker());
    }
    await Promise.all(workers);
  }
  async function generateRealExcel(products, priceMap, button) {
    const ExcelJS = await loadExcelJS();
    const workbook = new ExcelJS.Workbook();
    // Los ids de imagen pertenecen a un libro concreto: hay que vaciar la cache
    // en cada generacion o la segunda descarga de la misma pagina falla.
    workbookImageCache.clear();
    workbook.creator = "Sirena Internacional";
    workbook.company = "Sirena Internacional";
    workbook.subject = COLLECTION_TITLE;
    workbook.title = COLLECTION_TITLE;
    workbook.created = new Date();
    const worksheet = workbook.addWorksheet(
      safeSheetName(COLLECTION_TITLE),
      {
        properties: {
          defaultRowHeight: 18
        },
        pageSetup: {
          orientation: "landscape",
          fitToPage: true,
          fitToWidth: 1,
          fitToHeight: 0,
          paperSize: 9
        }
      }
    );

    // La columna Inventario solo existe si el cliente conectado tiene etiqueta
    // de lista de precio (lo decide templates/collection.precios.liquid).
    const mostrarInventario = !!(priceMap && priceMap.conInventario);
    const columnDefs = [
      { key: "number", header: "No.", width: 7 },
      { key: "image", header: "Imagen", width: 18 },
      { key: "product", header: "Producto", width: 34 },
      { key: "description", header: "Descripción", width: 52 },
      { key: "variant", header: "Variante", width: 24 },
      { key: "sku", header: "SKU", width: 19 },
      { key: "priceRegular", header: "Precio normal", width: 16 },
      { key: "priceOffer", header: "Precio al mayor", width: 17 },
      { key: "availability", header: "Disponibilidad", width: 17 }
    ];
    if (mostrarInventario) {
      columnDefs.push({ key: "inventory", header: "Inventario", width: 14 });
    }
    columnDefs.push({ key: "link", header: "Enlace", width: 22 });

    const col = {};
    columnDefs.forEach(function (definition, index) {
      col[definition.key] = index + 1;
    });
    const lastColumnLetter = String.fromCharCode(
      64 + columnDefs.length
    );

    worksheet.columns = columnDefs.map(function (definition) {
      return {
        header: "",
        key: definition.key,
        width: definition.width
      };
    });
    worksheet.mergeCells("A1:" + lastColumnLetter + "1");
    const titleCell = worksheet.getCell("A1");
    titleCell.value = COLLECTION_TITLE;
    titleCell.font = {
      name: "Arial",
      size: 20,
      bold: true,
      color: {
        argb: "FFFFFFFF"
      }
    };
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: {
        argb: "FF0B3A66"
      }
    };
    titleCell.alignment = {
      horizontal: "center",
      vertical: "middle"
    };
    worksheet.getRow(1).height = 34;
    const headerRow = worksheet.getRow(2);
    headerRow.values = columnDefs.map(function (definition) {
      return definition.header;
    });
    headerRow.height = 28;
    headerRow.eachCell(function (cell) {
      cell.font = {
        name: "Arial",
        size: 11,
        bold: true,
        color: {
          argb: "FFFFFFFF"
        }
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FF124F7D"
        }
      };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true
      };
      applyThinBorder(cell);
    });
    worksheet.views = [
      {
        state: "frozen",
        ySplit: 2
      }
    ];
    worksheet.autoFilter = {
      from: "A2",
      to: lastColumnLetter + "2"
    };
    const catalogItems = flattenProducts(products);
    const imageTasks = [];
    catalogItems.forEach(function (item, index) {
      const product = item.product;
      const variant = item.variant;
      const listInfo = priceMap.get(String(variant.id));
      const prices = resolvePrices(
        variant,
        listInfo
      );
      const stock = resolveStock(listInfo);
      const productLink = getProductLink(
        product,
        variant
      );
      const rowValues = {
        number: index + 1,
        image: "",
        product: product.title || "",
        description: cleanText(
          product.body_html
        ).slice(0, MAX_DESCRIPTION_LENGTH),
        variant: getVariantTitle(variant),
        sku: variant.sku || "",
        priceRegular: prices.normal,
        priceOffer: prices.offer,
        availability:
          variant.available === false
            ? "Agotado"
            : "Disponible",
        link: {
          text: "Abrir producto",
          hyperlink: productLink,
          tooltip: productLink
        }
      };
      if (mostrarInventario) {
        rowValues.inventory = stock.value;
      }
      const row = worksheet.addRow(rowValues);
      row.height = 82;
      const isAlternate = index % 2 === 1;
      row.eachCell(
        {
          includeEmpty: true
        },
        function (cell) {
          cell.font = {
            name: "Arial",
            size: 10,
            color: {
              argb: "FF1F2937"
            }
          };
          cell.alignment = {
            vertical: "middle",
            wrapText: true
          };
          if (isAlternate) {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: {
                argb: "FFF6F8FB"
              }
            };
          }
          applyThinBorder(cell);
        }
      );
      row.getCell(col.number).alignment = {
        horizontal: "center",
        vertical: "middle"
      };
      row.getCell(col.image).alignment = {
        horizontal: "center",
        vertical: "middle"
      };
      row.getCell(col.product).font = {
        name: "Arial",
        size: 11,
        bold: true,
        color: {
          argb: "FF0B3A66"
        }
      };
      row.getCell(col.description).font = {
        name: "Arial",
        size: 9,
        color: {
          argb: "FF374151"
        }
      };
      row.getCell(col.variant).alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true
      };
      row.getCell(col.sku).alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true
      };
      row.getCell(col.priceRegular).numFmt = '$#,##0.00';
      row.getCell(col.priceRegular).alignment = {
        horizontal: "center",
        vertical: "middle"
      };
      row.getCell(col.priceRegular).font = {
        name: "Arial",
        size: 11,
        bold: !prices.hasOffer,
        strike: prices.hasOffer,
        color: {
          argb: prices.hasOffer
            ? "FF9CA3AF"
            : "FF0B3A66"
        }
      };
      row.getCell(col.priceOffer).numFmt = '$#,##0.00';
      row.getCell(col.priceOffer).alignment = {
        horizontal: "center",
        vertical: "middle"
      };
      row.getCell(col.priceOffer).font = {
        name: "Arial",
        size: 12,
        bold: true,
        color: {
          argb: prices.hasOffer
            ? "FFB91C1C"
            : "FF0B3A66"
        }
      };

      if (prices.hasOffer) {
        row.getCell(col.priceOffer).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "FFFFF1F2"
          }
        };

        applyThinBorder(row.getCell(col.priceOffer));
      }

      row.getCell(col.availability).alignment = {
        horizontal: "center",
        vertical: "middle"
      };
      row.getCell(col.availability).font = {
        name: "Arial",
        size: 10,
        bold: true,
        color: {
          argb:
            variant.available === false
              ? "FFB91C1C"
              : "FF15803D"
        }
      };
      if (mostrarInventario) {
        const stockCell = row.getCell(col.inventory);
        stockCell.alignment = {
          horizontal: "center",
          vertical: "middle"
        };
        stockCell.font = {
          name: "Arial",
          size: 11,
          bold: stock.bold,
          color: {
            argb: stock.color
          }
        };
        if (typeof stock.value === "number") {
          stockCell.numFmt = "#,##0";
        }
      }
      row.getCell(col.link).alignment = {
        horizontal: "center",
        vertical: "middle"
      };
      row.getCell(col.link).font = {
        name: "Arial",
        size: 10,
        underline: true,
        color: {
          argb: "FF0563C1"
        }
      };
      const imageUrl = getVariantImage(
        product,
        variant
      );
      if (imageUrl) {
        imageTasks.push({
          rowNumber: row.number,
          imageUrl: imageUrl
        });
      }
    });
    button.textContent =
      "Preparando " +
      imageTasks.length +
      " imágenes...";
    await insertImages(
      workbook,
      worksheet,
      imageTasks,
      button
    );
    worksheet.getColumn(1).alignment = {
      horizontal: "center",
      vertical: "middle"
    };
    button.textContent = "Creando archivo .xlsx...";
    const excelBuffer =
      await workbook.xlsx.writeBuffer();
    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    const objectUrl = URL.createObjectURL(blob);
    const downloadLink =
      document.createElement("a");
    downloadLink.href = objectUrl;
    downloadLink.download =
      safeFileName(COLLECTION_HANDLE) +
      "-catalogo.xlsx";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
    setTimeout(function () {
      URL.revokeObjectURL(objectUrl);
    }, 3000);
  }
  document.addEventListener(
    "click",
    async function (event) {
      const button =
        event.target &&
        typeof event.target.closest === "function"
          ? event.target.closest(
              "#download-excel-catalog"
            )
          : null;
      if (!button || button.disabled) return;
      const originalContent = button.innerHTML;
      button.disabled = true;
      button.textContent =
        "Leyendo productos...";
      try {
        const products = await getProducts();
        if (!products.length) {
          throw new Error(
            "No se encontraron productos en esta colección."
          );
        }
        button.textContent =
          "Leyendo precios...";

        const priceMap = await getPriceMap();

        await generateRealExcel(
          products,
          priceMap,
          button
        );
      } catch (error) {
        console.error(error);
        alert(
          "No se pudo generar el Excel:\n" +
          (error && error.message
            ? error.message
            : "Error desconocido.")
        );
      } finally {
        button.disabled = false;
        button.innerHTML = originalContent;
      }
    }
  );
})();
